import { X } from "lucide-react";

import { IconProps } from "./icon-types";

export const XIcon = ({
  width = 20,
  height = 20,
  className,
  ...props
}: IconProps) => {
  return (
    <X
      width={width}
      height={height}
      className={className}
      strokeWidth={1}
      {...props}
    />
  );
};
